import React, { useEffect, useState } from 'react';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { getAllReference } from 'nursd-dashboard/api/reference';
import ReferenceTable from './table/ReferenceTable';
import PropTypes from 'prop-types';

const TabThree = ({ nurseId }) => {
  const { authToken } = useAuth();
  const [referenceData, setReferenceData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const checkUser = async (authToken, id) => {
    try {
      await getAllReference(authToken, id).then(res => {
        let array = [];
        for (let i = 0; i < res.length; i++) {
          const item = res[i];
          let obj = {
            ...item,
            avatar: {
              name: item.fullName
            }
          };
          array.push(obj);
        }
        setReferenceData(array);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (nurseId !== null) {
      checkUser(authToken, nurseId);
    }
  }, [nurseId, refresh]);

  return (
    <>
      <ReferenceTable
        referenceData={referenceData}
        nurseId={nurseId}
        refresh={refresh}
        setRefresh={setRefresh}
      />
    </>
  );
};

TabThree.propTypes = {
  nurseId: PropTypes.number
};

export default TabThree;
